/**
 * Batch #14.38 — Illustrations SVG inline pour les 8 guides web (sauf Immeuble).
 *
 * Même style que ImmeubleIllustrations.jsx : cadre fenêtre navigateur,
 * cohérent avec la palette du guide. Permet d'afficher des "captures"
 * réalistes sans seed de données ni PNG à uploader.
 *
 * Schema : { [slug]: SVGComponent }
 */

const W = 1200;
const H = 720;

// ============================================================
//  Helpers partagés
// ============================================================
export const Frame = ({ children, accent = "#0E7490" }) => (
  <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-auto bg-white" preserveAspectRatio="xMidYMid meet">
    <defs>
      <linearGradient id="grad-hero" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor={accent} />
        <stop offset="100%" stopColor="#1E40AF" />
      </linearGradient>
      <filter id="shadow" x="-2%" y="-2%" width="104%" height="108%">
        <feDropShadow dx="0" dy="2" stdDeviation="3" floodOpacity="0.08" />
      </filter>
    </defs>
    <rect x="0" y="0" width={W} height={H} fill="#F8FAFC" />
    {/* Window chrome */}
    <rect x="0" y="0" width={W} height="40" fill="#E2E8F0" />
    <circle cx="22" cy="20" r="6" fill="#EF4444" />
    <circle cx="44" cy="20" r="6" fill="#F59E0B" />
    <circle cx="66" cy="20" r="6" fill="#10B981" />
    <rect x="100" y="11" width="980" height="18" rx="9" fill="#F1F5F9" />
    <text x="120" y="24" fontFamily="ui-monospace, monospace" fontSize="11" fill="#64748B">portal.dgcomptabilite.ca</text>
    {children}
  </svg>
);

export const T = ({ x, y, children, size = 13, w = 400, color = "#334155", anchor = "start" }) => (
  <text x={x} y={y} fontFamily="system-ui, sans-serif" fontSize={size} fontWeight={w} fill={color} textAnchor={anchor}>{children}</text>
);

export const Pill = ({ x, y, w = 60, label, fill = "#10B981", textFill = "white" }) => (
  <g>
    <rect x={x} y={y} width={w} height="22" rx="11" fill={fill} />
    <text x={x + w / 2} y={y + 15} fontFamily="system-ui, sans-serif" fontSize="11" fontWeight="600" fill={textFill} textAnchor="middle">{label}</text>
  </g>
);

// ============================================================
//  1. DOCUMENTS — liste-documents
// ============================================================
export function ListeDocuments() {
  const docs = [
    { name: "Déclaration T1 — 2025.pdf",         from: "DG Comptabilité", date: "12 fév", unread: true,  size: "2.1 Mo", icon: "📄" },
    { name: "Sommaire TP1 — 2025.pdf",           from: "DG Comptabilité", date: "12 fév", unread: true,  size: "1.4 Mo", icon: "📊" },
    { name: "Avis de cotisation ARC — 2024.pdf", from: "DG Comptabilité", date: "28 jan", unread: false, size: "856 ko", icon: "🏛️" },
    { name: "Attestation employeur — 2025.pdf",  from: "DG Comptabilité", date: "20 jan", unread: false, size: "224 ko", icon: "✉️" },
    { name: "Plan financier — 2025.pdf",         from: "DG Comptabilité", date: "15 jan", unread: false, size: "1.8 Mo", icon: "📈" },
  ];
  return (
    <Frame accent="#2563EB">
      <rect x="0" y="40" width={W} height="80" fill="url(#grad-hero)" />
      <T x="40" y="80" size="22" w="700" color="white">📁 Mes documents</T>
      <T x="40" y="102" size="13" color="#BFDBFE">{docs.length} documents · 2 non lus</T>
      <Pill x="1050" y="68" w="130" label="🔍 Rechercher" fill="white" textFill="#2563EB" />

      <rect x="40" y="160" width="1120" height="500" rx="12" fill="white" stroke="#E2E8F0" filter="url(#shadow)" />
      {/* Headers */}
      <rect x="40" y="160" width="1120" height="40" fill="#F8FAFC" />
      <T x="80" y="186" size="11" w="700" color="#64748B">DOCUMENT</T>
      <T x="700" y="186" size="11" w="700" color="#64748B">DE</T>
      <T x="870" y="186" size="11" w="700" color="#64748B">REÇU LE</T>
      <T x="1010" y="186" size="11" w="700" color="#64748B">TAILLE</T>

      {docs.map((d, i) => (
        <g key={i}>
          <line x1="40" y1={200 + i * 90} x2="1160" y2={200 + i * 90} stroke="#F1F5F9" />
          {d.unread && <circle cx="60" cy={244 + i * 90} r="4" fill="#3B82F6" />}
          <rect x="76" y={222 + i * 90} width="48" height="48" rx="10" fill={d.unread ? "#DBEAFE" : "#F1F5F9"} />
          <text x="100" y={254 + i * 90} fontSize="26" textAnchor="middle">{d.icon}</text>
          <T x="140" y={244 + i * 90} size="14" w={d.unread ? "700" : "500"} color="#1E293B">{d.name}</T>
          <T x="140" y={264 + i * 90} size="11" color="#94A3B8">{d.unread ? "Nouveau · Cliquez pour ouvrir" : "Lu"}</T>
          <T x="700" y={244 + i * 90} size="12" color="#475569">{d.from}</T>
          <T x="870" y={244 + i * 90} size="12" color="#475569">{d.date}</T>
          <T x="1010" y={244 + i * 90} size="12" color="#475569">{d.size}</T>
          <text x="1110" y={245 + i * 90} fontFamily="system-ui" fontSize="12" fontWeight="600" fill="#2563EB" textAnchor="middle">⬇ Ouvrir</text>
        </g>
      ))}
    </Frame>
  );
}

// ============================================================
//  2. ENVOYER — envoyer-formulaire
// ============================================================
export function EnvoyerFormulaire() {
  return (
    <Frame accent="#059669">
      <rect x="0" y="40" width={W} height="80" fill="url(#grad-hero)" />
      <T x="40" y="80" size="22" w="700" color="white">📤 Envoyer un fichier</T>
      <T x="40" y="102" size="13" color="#A7F3D0">Téléversez vos T4, factures, reçus...</T>

      <rect x="40" y="160" width="700" height="500" rx="12" fill="white" stroke="#E2E8F0" filter="url(#shadow)" />

      {/* Catégorie */}
      <T x="70" y="200" size="11" w="700" color="#64748B">CATÉGORIE</T>
      {[
        { x: 70, y: 220, label: "T4 / T5", color: "#10B981", active: true },
        { x: 180, y: 220, label: "Reçu", color: "#3B82F6" },
        { x: 290, y: 220, label: "Contrat", color: "#A855F7" },
        { x: 400, y: 220, label: "Facture", color: "#F59E0B" },
        { x: 510, y: 220, label: "Autre", color: "#64748B" },
      ].map((b, i) => (
        <g key={i}>
          <rect x={b.x} y={b.y} width="100" height="36" rx="8" fill={b.active ? b.color : "white"} stroke={b.color} />
          <T x={b.x + 50} y={b.y + 23} size="12" w={b.active ? "700" : "500"} color={b.active ? "white" : b.color} anchor="middle">{b.label}</T>
        </g>
      ))}

      {/* Zone drop */}
      <rect x="70" y="290" width="640" height="240" rx="14" fill="#ECFDF5" stroke="#10B981" strokeDasharray="8 6" />
      <text x="390" y="395" fontSize="50" textAnchor="middle">📎</text>
      <T x="390" y="450" size="16" w="700" color="#059669" anchor="middle">Glissez votre fichier ici</T>
      <T x="390" y="475" size="12" color="#10B981" anchor="middle">ou cliquez pour parcourir · PDF, JPG, PNG, HEIC, Word, Excel</T>
      <T x="390" y="500" size="11" color="#34D399" anchor="middle">Taille max : 25 Mo</T>

      {/* Note */}
      <T x="70" y="565" size="11" w="700" color="#64748B">NOTE (OPTIONNEL)</T>
      <rect x="70" y="575" width="640" height="44" rx="8" fill="#F8FAFC" stroke="#CBD5E1" />
      <T x="84" y="601" size="12" color="#94A3B8">Ex: 3e T4 reçu de Walmart en retard...</T>

      {/* Sidebar récap */}
      <rect x="780" y="160" width="380" height="500" rx="12" fill="white" stroke="#E2E8F0" filter="url(#shadow)" />
      <rect x="780" y="160" width="380" height="60" rx="12" fill="#059669" />
      <T x="970" y="196" size="14" w="700" color="white" anchor="middle">FICHIER SÉLECTIONNÉ</T>

      <rect x="810" y="260" width="50" height="64" rx="6" fill="#DC2626" />
      <T x="835" y="298" size="14" w="700" color="white" anchor="middle">PDF</T>
      <T x="880" y="280" size="13" w="700" color="#1E293B">T4_2025_Walmart.pdf</T>
      <T x="880" y="300" size="11" color="#94A3B8">1.2 Mo · PDF</T>
      <T x="880" y="320" size="11" color="#10B981">✓ Prêt à envoyer</T>

      <rect x="810" y="600" width="320" height="40" rx="8" fill="#10B981" />
      <T x="970" y="625" size="13" w="700" color="white" anchor="middle">📤 Envoyer à l'équipe</T>
    </Frame>
  );
}

// ============================================================
//  3. CHAT — chat-conversation
// ============================================================
export function ChatConversation() {
  return (
    <Frame accent="#4F46E5">
      <rect x="0" y="40" width={W} height="80" fill="url(#grad-hero)" />
      <T x="40" y="80" size="22" w="700" color="white">💬 Chat avec votre conseiller</T>
      <T x="40" y="102" size="13" color="#C7D2FE">Dominik Gougeon · Disponible</T>
      <circle cx="1100" cy="80" r="8" fill="#10B981" />
      <T x="1115" y="84" size="13" w="600" color="white">En ligne</T>

      <rect x="40" y="160" width="1120" height="500" rx="12" fill="white" stroke="#E2E8F0" filter="url(#shadow)" />

      {/* Date separator */}
      <line x1="60" y1="200" x2="500" y2="200" stroke="#E2E8F0" />
      <T x="580" y="205" size="11" color="#94A3B8" anchor="middle">Aujourd'hui · 14h22</T>
      <line x1="660" y1="200" x2="1140" y2="200" stroke="#E2E8F0" />

      {/* Messages */}
      {/* Client message 1 */}
      <circle cx="80" cy="250" r="20" fill="#DBEAFE" />
      <T x="80" y="256" size="14" w="700" color="#2563EB" anchor="middle">M</T>
      <rect x="110" y="234" width="500" height="56" rx="14" fill="#F1F5F9" />
      <T x="130" y="258" size="13" color="#1E293B">Bonjour, j'ai reçu mon avis de cotisation hier...</T>
      <T x="130" y="278" size="13" color="#1E293B">Le montant ne correspond pas à ce qu'on avait prévu.</T>
      <T x="130" y="298" size="10" color="#94A3B8">Marie · 14h22 ✓✓</T>

      {/* Cabinet reply */}
      <rect x="660" y="330" width="460" height="86" rx="14" fill="#4F46E5" />
      <T x="680" y="356" size="13" color="white">Bonjour Marie ! Je regarde tout de suite votre avis.</T>
      <T x="680" y="376" size="13" color="white">Pouvez-vous m'envoyer la copie via la tuile</T>
      <T x="680" y="396" size="13" color="white">« Envoyer un fichier » ? Je l'examine et reviens vers vous.</T>
      <T x="1100" y="420" size="10" color="#C7D2FE" anchor="end">DG · 14h28</T>
      <circle cx="1140" cy="370" r="20" fill="#4F46E5" stroke="white" strokeWidth="2" />
      <T x="1140" y="376" size="14" w="700" color="white" anchor="middle">DG</T>

      {/* Client reply with attachment */}
      <circle cx="80" cy="470" r="20" fill="#DBEAFE" />
      <T x="80" y="476" size="14" w="700" color="#2563EB" anchor="middle">M</T>
      <rect x="110" y="450" width="280" height="60" rx="14" fill="#F1F5F9" />
      <rect x="125" y="465" width="36" height="30" rx="5" fill="#DC2626" />
      <T x="143" y="486" size="11" w="700" color="white" anchor="middle">PDF</T>
      <T x="175" y="476" size="12" w="600" color="#1E293B">Avis_ARC_2024.pdf</T>
      <T x="175" y="492" size="10" color="#94A3B8">1.4 Mo · envoyé</T>
      <T x="130" y="528" size="10" color="#94A3B8">Marie · 14h31 ✓✓</T>

      {/* Input bar */}
      <rect x="60" y="590" width="950" height="48" rx="24" fill="#F8FAFC" stroke="#CBD5E1" />
      <T x="80" y="619" size="13" color="#94A3B8">Tapez votre message...</T>
      <text x="975" y="619" fontSize="20" textAnchor="middle">📎</text>
      <rect x="1020" y="594" width="120" height="40" rx="20" fill="#4F46E5" />
      <T x="1080" y="619" size="13" w="700" color="white" anchor="middle">Envoyer →</T>
    </Frame>
  );
}

// ============================================================
//  4. RDV — rdv-creneaux
// ============================================================
export function RdvCreneaux() {
  return (
    <Frame accent="#7C3AED">
      <rect x="0" y="40" width={W} height="80" fill="url(#grad-hero)" />
      <T x="40" y="80" size="22" w="700" color="white">📅 Prendre un rendez-vous</T>
      <T x="40" y="102" size="13" color="#DDD6FE">Choisissez le type, la durée et un créneau</T>

      {/* Choix type */}
      <T x="40" y="160" size="11" w="700" color="#64748B">TYPE DE RENCONTRE</T>
      {[
        { x: 40, label: "🎥 Vidéo (Meet)", active: true },
        { x: 230, label: "📞 Téléphone" },
        { x: 410, label: "🏢 En personne" },
      ].map((t, i) => (
        <g key={i}>
          <rect x={t.x} y="170" width="170" height="50" rx="10" fill={t.active ? "#7C3AED" : "white"} stroke="#7C3AED" />
          <T x={t.x + 85} y="201" size="13" w={t.active ? "700" : "600"} color={t.active ? "white" : "#7C3AED"} anchor="middle">{t.label}</T>
        </g>
      ))}

      {/* Durée */}
      <T x="650" y="160" size="11" w="700" color="#64748B">DURÉE</T>
      {[
        { x: 650, label: "30 min" },
        { x: 740, label: "60 min", active: true },
        { x: 830, label: "90 min" },
      ].map((d, i) => (
        <g key={i}>
          <rect x={d.x} y="170" width="80" height="50" rx="10" fill={d.active ? "#7C3AED" : "white"} stroke="#7C3AED" />
          <T x={d.x + 40} y="201" size="13" w="600" color={d.active ? "white" : "#7C3AED"} anchor="middle">{d.label}</T>
        </g>
      ))}

      {/* Calendrier creneaux */}
      <rect x="40" y="260" width="1120" height="400" rx="12" fill="white" stroke="#E2E8F0" filter="url(#shadow)" />
      <T x="60" y="295" size="14" w="700" color="#1E293B">Créneaux disponibles · Semaine du 18 février</T>

      {[
        { day: "Lun 18", slots: ["09:00", "10:30", "14:00"] },
        { day: "Mar 19", slots: ["11:00", "15:30"] },
        { day: "Mer 20", slots: ["09:30", "13:00", "16:00"] },
        { day: "Jeu 21", slots: ["10:00", "14:30"] },
        { day: "Ven 22", slots: ["08:30", "11:30", "15:00"] },
      ].map((col, ci) => (
        <g key={ci}>
          <T x={100 + ci * 220} y="335" size="13" w="700" color="#7C3AED">{col.day}</T>
          {col.slots.map((s, si) => (
            <g key={si}>
              <rect
                x={70 + ci * 220} y={360 + si * 70} width="180" height="56" rx="10"
                fill={ci === 2 && si === 1 ? "#7C3AED" : "white"}
                stroke="#A78BFA"
              />
              <T x={160 + ci * 220} y={385 + si * 70} size="16" w="700" color={ci === 2 && si === 1 ? "white" : "#7C3AED"} anchor="middle">{s}</T>
              <T x={160 + ci * 220} y={405 + si * 70} size="10" color={ci === 2 && si === 1 ? "#DDD6FE" : "#A78BFA"} anchor="middle">{ci === 2 && si === 1 ? "✓ Sélectionné" : "Disponible"}</T>
            </g>
          ))}
        </g>
      ))}
    </Frame>
  );
}

// ============================================================
//  5. MANDATS — mandat-signature
// ============================================================
export function MandatSignature() {
  return (
    <Frame accent="#E11D48">
      <rect x="0" y="40" width={W} height="80" fill="url(#grad-hero)" />
      <T x="40" y="80" size="22" w="700" color="white">✍️ Mandat T1198 — À signer</T>
      <T x="40" y="102" size="13" color="#FECDD3">Autorisation représentation fiscale · DG Comptabilité</T>

      {/* PDF preview */}
      <rect x="40" y="160" width="700" height="500" rx="12" fill="white" stroke="#E2E8F0" filter="url(#shadow)" />
      <rect x="40" y="160" width="700" height="44" rx="12" fill="#F1F5F9" />
      <T x="60" y="187" size="12" w="700" color="#475569">📄 mandat-T1198-marie-tremblay-2025.pdf</T>
      <T x="690" y="187" size="11" color="#94A3B8" anchor="end">Page 2 / 3</T>

      {/* Faux contenu PDF */}
      <T x="80" y="240" size="13" w="700" color="#1E293B">AUTORISATION DE REPRÉSENTATION FISCALE</T>
      {[260, 280, 300, 320, 360, 380, 400, 440, 460].map((y, i) => (
        <rect key={i} x="80" y={y} width={550 - (i % 3) * 70} height="6" rx="3" fill="#E2E8F0" />
      ))}
      <T x="80" y="510" size="12" w="700" color="#1E293B">Le mandataire :</T>
      <rect x="80" y="525" width="280" height="6" rx="3" fill="#E2E8F0" />
      <T x="80" y="560" size="12" w="700" color="#1E293B">Le mandant :</T>
      <rect x="80" y="575" width="280" height="6" rx="3" fill="#E2E8F0" />

      {/* Sidebar signature */}
      <rect x="780" y="160" width="380" height="500" rx="12" fill="white" stroke="#E2E8F0" filter="url(#shadow)" />
      <rect x="780" y="160" width="380" height="60" rx="12" fill="#E11D48" />
      <T x="970" y="196" size="14" w="700" color="white" anchor="middle">VOTRE SIGNATURE</T>

      <T x="810" y="260" size="11" w="700" color="#64748B">SIGNATAIRE</T>
      <T x="810" y="280" size="14" w="600" color="#1E293B">Marie-Claire Tremblay</T>

      <T x="810" y="320" size="11" w="700" color="#64748B">DATE DE SIGNATURE</T>
      <T x="810" y="340" size="13" color="#1E293B">17 février 2026 · 14h32</T>

      {/* Canvas signature */}
      <rect x="810" y="370" width="320" height="120" rx="10" fill="#FEF2F2" stroke="#E11D48" strokeDasharray="5 5" />
      <path d="M 830 440 Q 870 410, 900 430 T 970 425 Q 1010 415, 1050 440 L 1100 445" stroke="#1E293B" strokeWidth="2.5" fill="none" />
      <T x="970" y="475" size="10" color="#9F1239" anchor="middle">✏️ Signez ci-dessus avec votre souris ou doigt</T>

      <rect x="810" y="510" width="320" height="36" rx="6" fill="#FEF2F2" stroke="#FDA4AF" />
      <rect x="822" y="520" width="14" height="14" rx="3" fill="#10B981" />
      <T x="829" y="531" size="9" w="700" color="white" anchor="middle">✓</T>
      <T x="845" y="531" size="11" color="#9F1239">J'accepte les termes du mandat</T>

      <rect x="810" y="600" width="320" height="44" rx="10" fill="#E11D48" />
      <T x="970" y="628" size="13" w="700" color="white" anchor="middle">🔒 Confirmer ma signature</T>
    </Frame>
  );
}

// ============================================================
//  6. FACTURES — facture-detail
// ============================================================
export function FactureDetail() {
  return (
    <Frame accent="#D97706">
      <rect x="0" y="40" width={W} height="80" fill="url(#grad-hero)" />
      <T x="40" y="80" size="22" w="700" color="white">💰 Facture #FAC-2025-0142</T>
      <T x="40" y="102" size="13" color="#FED7AA">Émise le 12 février 2026 · Échéance 14 mars</T>
      <Pill x="1020" y="68" w="120" label="● À PAYER" fill="white" textFill="#D97706" />

      {/* Left : Items */}
      <rect x="40" y="160" width="760" height="500" rx="12" fill="white" stroke="#E2E8F0" filter="url(#shadow)" />
      <T x="60" y="200" size="14" w="700" color="#1E293B">📋 Détail des services</T>
      <line x1="60" y1="215" x2="780" y2="215" stroke="#E2E8F0" />

      {[
        { label: "Déclaration T1 personnelle 2025", qty: 1, price: 250 },
        { label: "Déclaration TP1 Québec 2025", qty: 1, price: 150 },
        { label: "Conjoint TP1 + T1 (forfait couple)", qty: 1, price: 200 },
        { label: "Rapport d'impôt immeuble (T776)", qty: 2, price: 75 },
        { label: "Bureau à domicile (T777)", qty: 1, price: 50 },
      ].map((it, i) => (
        <g key={i}>
          <T x="60" y={260 + i * 50} size="13" color="#1E293B">{it.label}</T>
          <T x="640" y={260 + i * 50} size="12" color="#64748B" anchor="end">{it.qty} × {it.price.toFixed(2)} $</T>
          <T x="780" y={260 + i * 50} size="13" w="700" color="#1E293B" anchor="end">{(it.qty * it.price).toFixed(2)} $</T>
          <line x1="60" y1={275 + i * 50} x2="780" y2={275 + i * 50} stroke="#F1F5F9" />
        </g>
      ))}

      {/* Totaux */}
      <line x1="60" y1="520" x2="780" y2="520" stroke="#E2E8F0" strokeWidth="2" />
      <T x="500" y="550" size="12" color="#64748B" anchor="end">Sous-total :</T>
      <T x="780" y="550" size="13" w="700" color="#1E293B" anchor="end">800,00 $</T>
      <T x="500" y="572" size="12" color="#64748B" anchor="end">TPS (5%) :</T>
      <T x="780" y="572" size="13" color="#1E293B" anchor="end">40,00 $</T>
      <T x="500" y="594" size="12" color="#64748B" anchor="end">TVQ (9,975%) :</T>
      <T x="780" y="594" size="13" color="#1E293B" anchor="end">79,80 $</T>
      <line x1="500" y1="610" x2="780" y2="610" stroke="#D97706" strokeWidth="2" />
      <T x="500" y="636" size="14" w="700" color="#1E293B" anchor="end">TOTAL :</T>
      <T x="780" y="636" size="20" w="700" color="#D97706" anchor="end">919,80 $</T>

      {/* Right : payment options */}
      <rect x="820" y="160" width="340" height="500" rx="12" fill="white" stroke="#E2E8F0" filter="url(#shadow)" />
      <T x="840" y="200" size="14" w="700" color="#1E293B">💳 Modes de paiement</T>

      {[
        { y: 240, icon: "💳", title: "Carte (Stripe)", desc: "Visa · MasterCard · AMEX", color: "#10B981", bg: "#D1FAE5" },
        { y: 340, icon: "🏦", title: "Virement Interac", desc: "dgfiscalflow@dgcomptabilite.ca", color: "#3B82F6", bg: "#DBEAFE" },
        { y: 440, icon: "📝", title: "Chèque", desc: "À l'ordre de Dominik Gougeon", color: "#F59E0B", bg: "#FEF3C7" },
      ].map((p, i) => (
        <g key={i}>
          <rect x="840" y={p.y} width="300" height="80" rx="10" fill={p.bg} stroke={p.color} />
          <text x="870" y={p.y + 48} fontSize="32" textAnchor="middle">{p.icon}</text>
          <T x="910" y={p.y + 32} size="13" w="700" color="#1E293B">{p.title}</T>
          <T x="910" y={p.y + 52} size="11" color="#64748B">{p.desc}</T>
        </g>
      ))}

      <rect x="840" y="610" width="300" height="36" rx="8" fill="#D97706" />
      <T x="990" y="635" size="13" w="700" color="white" anchor="middle">💳 Payer maintenant</T>
    </Frame>
  );
}

// ============================================================
//  7. T777 — t777-formulaire
// ============================================================
export function T777Formulaire() {
  return (
    <Frame accent="#D97706">
      <rect x="0" y="40" width={W} height="80" fill="url(#grad-hero)" />
      <T x="40" y="80" size="22" w="700" color="white">🏡 Bureau à domicile — T777 2025</T>
      <T x="40" y="102" size="13" color="#FED7AA">Année fiscale en cours · Dernière modification : aujourd'hui</T>

      <rect x="40" y="160" width="1120" height="500" rx="12" fill="white" stroke="#E2E8F0" filter="url(#shadow)" />

      {/* Section: Superficies */}
      <T x="70" y="200" size="14" w="700" color="#1E293B">📐 SUPERFICIES</T>
      <line x1="70" y1="212" x2="1130" y2="212" stroke="#F1F5F9" />
      <T x="70" y="245" size="11" w="700" color="#64748B">SUPERFICIE BUREAU</T>
      <rect x="70" y="255" width="240" height="44" rx="8" fill="#F8FAFC" stroke="#CBD5E1" />
      <T x="86" y="282" size="14" w="700" color="#1E293B">120 pi²</T>

      <T x="350" y="245" size="11" w="700" color="#64748B">SUPERFICIE TOTALE</T>
      <rect x="350" y="255" width="240" height="44" rx="8" fill="#F8FAFC" stroke="#CBD5E1" />
      <T x="366" y="282" size="14" w="700" color="#1E293B">1 200 pi²</T>

      <rect x="630" y="255" width="200" height="44" rx="8" fill="#D1FAE5" stroke="#10B981" />
      <T x="650" y="275" size="10" w="700" color="#065F46">RATIO BUREAU</T>
      <T x="650" y="293" size="14" w="700" color="#065F46">10 %</T>

      {/* Section: Dépenses */}
      <T x="70" y="350" size="14" w="700" color="#1E293B">💰 DÉPENSES ANNUELLES 2025</T>
      <line x1="70" y1="362" x2="1130" y2="362" stroke="#F1F5F9" />
      {[
        { x: 70, y: 395, label: "Loyer / Intérêts hypothécaires", value: "18 000 $", icon: "🏠" },
        { x: 380, y: 395, label: "Électricité", value: "1 800 $", icon: "⚡" },
        { x: 690, y: 395, label: "Chauffage", value: "1 200 $", icon: "🔥" },
        { x: 70, y: 475, label: "Internet", value: "720 $", icon: "🌐" },
        { x: 380, y: 475, label: "Assurance habitation", value: "950 $", icon: "🛡️" },
        { x: 690, y: 475, label: "Eau / Aqueduc", value: "450 $", icon: "💧" },
      ].map((f, i) => (
        <g key={i}>
          <T x={f.x} y={f.y} size="11" w="700" color="#64748B">{f.label.toUpperCase()}</T>
          <rect x={f.x} y={f.y + 10} width="280" height="48" rx="10" fill="#FFFBEB" stroke="#FCD34D" />
          <text x={f.x + 25} y={f.y + 42} fontSize="20" textAnchor="middle">{f.icon}</text>
          <T x={f.x + 55} y={f.y + 41} size="14" w="700" color="#92400E">{f.value}</T>
        </g>
      ))}

      {/* Summary footer */}
      <rect x="70" y="585" width="1060" height="50" rx="10" fill="#FEF3C7" stroke="#F59E0B" />
      <T x="90" y="615" size="13" w="700" color="#92400E">📊 Total annuel saisi : 23 120 $ · Part déductible (10%) : 2 312 $ estimés</T>
      <rect x="990" y="595" width="120" height="30" rx="6" fill="#F59E0B" />
      <T x="1050" y="615" size="12" w="700" color="white" anchor="middle">Enregistrer ✓</T>
    </Frame>
  );
}

// ============================================================
//  8. PROFIL — profil-formulaire
// ============================================================
export function ProfilFormulaire() {
  return (
    <Frame accent="#0891B2">
      <rect x="0" y="40" width={W} height="80" fill="url(#grad-hero)" />
      <T x="40" y="80" size="22" w="700" color="white">👤 Mon profil</T>
      <T x="40" y="102" size="13" color="#A5F3FC">Gérez vos informations et la sécurité de votre compte</T>

      {/* Card 1 : Infos perso */}
      <rect x="40" y="160" width="720" height="500" rx="12" fill="white" stroke="#E2E8F0" filter="url(#shadow)" />
      <T x="70" y="200" size="14" w="700" color="#1E293B">📋 Informations personnelles</T>
      <line x1="70" y1="212" x2="740" y2="212" stroke="#F1F5F9" />

      {[
        { x: 70, y: 235, label: "Prénom", value: "Marie-Claire" },
        { x: 405, y: 235, label: "Nom", value: "Tremblay" },
        { x: 70, y: 310, label: "Courriel", value: "marie.tremblay@gmail.com", w: 670 },
        { x: 70, y: 385, label: "Téléphone", value: "418 555-0142" },
        { x: 405, y: 385, label: "NAS (chiffré)", value: "••• ••• 142", lock: true },
        { x: 70, y: 460, label: "Adresse postale", value: "123 rue Saint-Jean", w: 670 },
        { x: 70, y: 535, label: "Ville", value: "Québec" },
        { x: 270, y: 535, label: "Province", value: "QC" },
        { x: 405, y: 535, label: "Code postal", value: "G1A 1B2" },
      ].map((f, i) => (
        <g key={i}>
          <T x={f.x} y={f.y} size="10" w="700" color="#64748B">{f.label.toUpperCase()}</T>
          <rect x={f.x} y={f.y + 8} width={f.w || (f.x === 270 ? 100 : 310)} height="40" rx="8" fill="#F8FAFC" stroke="#CBD5E1" />
          <T x={f.x + 12} y={f.y + 33} size="13" color="#1E293B">{f.value}</T>
          {f.lock && <text x={(f.w || 310) + f.x - 16} y={f.y + 35} fontSize="13" textAnchor="middle">🔒</text>}
        </g>
      ))}

      <rect x="600" y="610" width="140" height="36" rx="8" fill="#0891B2" />
      <T x="670" y="635" size="12" w="700" color="white" anchor="middle">💾 Enregistrer</T>

      {/* Card 2 : Sécurité + PWA */}
      <rect x="780" y="160" width="380" height="500" rx="12" fill="white" stroke="#E2E8F0" filter="url(#shadow)" />
      <T x="810" y="200" size="14" w="700" color="#1E293B">🔐 Sécurité</T>
      <line x1="810" y1="212" x2="1140" y2="212" stroke="#F1F5F9" />

      <rect x="810" y="240" width="320" height="60" rx="10" fill="#F0F9FF" />
      <text x="830" y="278" fontSize="22" textAnchor="middle">🔑</text>
      <T x="860" y="265" size="12" w="700" color="#1E293B">Changer mon mot de passe</T>
      <T x="860" y="284" size="10" color="#64748B">Dernière modif : il y a 3 mois</T>

      <rect x="810" y="320" width="320" height="60" rx="10" fill="#FEF3C7" />
      <text x="830" y="358" fontSize="22" textAnchor="middle">🚪</text>
      <T x="860" y="345" size="12" w="700" color="#1E293B">Déconnecter tous les appareils</T>
      <T x="860" y="364" size="10" color="#92400E">3 sessions actives</T>

      <T x="810" y="420" size="14" w="700" color="#1E293B">📱 Installer comme app</T>
      <line x1="810" y1="432" x2="1140" y2="432" stroke="#F1F5F9" />

      {[
        { y: 450, icon: "🍎", title: "iPhone", desc: "Safari → Partager → Sur l'écran" },
        { y: 510, icon: "🤖", title: "Android", desc: "Chrome → ⋮ → Écran d'accueil" },
        { y: 570, icon: "💻", title: "Ordinateur", desc: "Chrome → ⋮ → Installer" },
      ].map((p, i) => (
        <g key={i}>
          <rect x="810" y={p.y} width="320" height="50" rx="10" fill="#F8FAFC" stroke="#E2E8F0" />
          <text x="830" y={p.y + 34} fontSize="20" textAnchor="middle">{p.icon}</text>
          <T x="860" y={p.y + 22} size="12" w="700" color="#1E293B">{p.title}</T>
          <T x="860" y={p.y + 41} size="10" color="#64748B">{p.desc}</T>
        </g>
      ))}
    </Frame>
  );
}

// ============================================================
//  Map slug → composant
// ============================================================
export const WEB_GUIDE_ILLUSTRATIONS = {
  "liste-documents":     ListeDocuments,
  "envoyer-formulaire":  EnvoyerFormulaire,
  "chat-conversation":   ChatConversation,
  "rdv-creneaux":        RdvCreneaux,
  "mandat-signature":    MandatSignature,
  "facture-detail":      FactureDetail,
  "t777-formulaire":     T777Formulaire,
  "profil-formulaire":   ProfilFormulaire,
};
